<template>
    <RolesSettings></RolesSettings>
</template>

<script>
import RolesSettings from '@/components/configuration/roles/RolesSettings.vue'

export default {
  data: function() {
        return {

        }
    },
    computed: {

    },
    methods: {

    },
    components: {
        RolesSettings
    }
}
</script>

<style>

</style>
